import { render, staticRenderFns } from "./JitsiMeeting.vue?vue&type=template&id=122bd5bc&scoped=true&"
import script from "./JitsiMeeting.vue?vue&type=script&lang=js&"
export * from "./JitsiMeeting.vue?vue&type=script&lang=js&"
import style0 from "./JitsiMeeting.vue?vue&type=style&index=0&id=122bd5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122bd5bc",
  null
  
)

export default component.exports